import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit{

  @Input("itens") itens;
  public listItens = [{
    text: "Home",
    routerLink: "/"
  }];

  constructor(){ }

  /**
   * 
   * Seta os itens do breadcrumbs
   * 
   */
  setItens(){
    
    if(typeof(this.itens) != "undefined"){
          
      if(typeof(this.itens) == "string"){
        this.itens = JSON.parse(this.itens);
      }
    
      this.listItens = this.listItens.concat(this.itens);
    
    }  
  
  }
  /**
  * 
  * Inicializa as Funções
  * 
  * 
  */
  ngOnInit(){
   this.setItens();
  } 

}
